import type {ReactElement} from 'react';
import {useEffect, useState} from 'react';
import type {GoogleMapProps} from '@Components/google-map/google-map.types';
import {getGoogleMapEmbedSrcLocationFromVenue} from './google-map.helper';
import {SkeletonBrick, SkeletonBrickTheme} from '@Components/skeleton-brick';

export function GoogleMap({googleMapAPIKey, defaultLocation}: GoogleMapProps): ReactElement<any> {
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const iframeSrc = getGoogleMapEmbedSrcLocationFromVenue(defaultLocation, googleMapAPIKey);

  useEffect(() => {
    setIsLoading(true);
  }, [defaultLocation]);

  const handleMapLoad = (): void => {
    setIsLoading(false);
  };

  return (
    <div className="google-map-container _full-height _full-width">
      {isLoading ? <SkeletonBrick isPulsating theme={SkeletonBrickTheme.LIGHT_TWO} className="_full-height" /> : undefined}

      <iframe
        key={iframeSrc}
        className="_full-height _full-width _no-border"
        src={iframeSrc}
        onLoad={handleMapLoad}
        style={{visibility: isLoading ? 'hidden' : 'visible'}}
        title="Google Map Location"
      ></iframe>
    </div>
  );
}
